<template>
  <div>
    <template v-if="loading">
      <div class="text-xs-center" style="padding: 10px 0px">
        <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
      </div>
    </template>
    <template v-else>
      <div
        v-if="broadcastItems && broadcastItems.length > 0"
        class="mt-4"
        style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px"
      >
        <div class="broadcasts">
          <div
            v-for="(broadcast, index) in broadcastItems"
            :key="'broadcast_' + index"
            class="broadcast mb-3"
          >
            <broadcast-item
              :broadcast="broadcast"
              :index="index"
              :draft="['schedule', 'draft'].includes(broadcast.status)"
              :is-save-only="true"
              @editBroadcast="editBroadcast"
              @copyBroadcast="copyBroadcast"
              @deleteBroadcast="deleteBroadcast"
              @viewBroadcast="viewBroadcast"
            ></broadcast-item>
          </div>
        </div>
        <div class="mt-2">
          <v-layout justify-center>
            <v-pagination
              v-model="pageNumber"
              :total-visible="6"
              :length="pageLength"
              @input="handleChangePage"
            ></v-pagination
          ></v-layout>
        </div>
      </div>
    </template>

    <BroadcastViewDialog
      :selected-view-item="selectedViewBroadcast"
      :open="viewBroadcastDialogOpen"
      @onClose="
        viewBroadcastDialogOpen = false
        selectedViewBroadcast = undefined
      "
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BroadcastItem from '@/components/view/broadcast/BroadcastItem'
import BroadcastViewDialog from '@/features/tcp/Broadcast/BroadcastViewDialog'

export default {
  components: {
    BroadcastItem,
    BroadcastViewDialog
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    totalItem: {
      type: Number,
      default: 0
    },
    pageLimit: {
      type: Number,
      default: 10
    },
    pageOffset: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      broadcastItems: null,
      loading: false,
      limit: this.pageLimit,
      offset: this.pageOffset,
      pagetmp: 1,
      pageNumber: 1,
      total: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      selectedViewBroadcast: undefined,
      viewBroadcastDialogOpen: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.broadcastItems = this.value
      }
    },
    totalItem(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.total = this.totalItem
      }
    }
  },
  mounted() {
    if (this.value) {
      this.broadcastItems = this.value
    }
  },
  methods: {
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }

        vm.$emit('onNextPage', vm.offset)
      }
    },

    copyBroadcast: function (payload) {
      const vm = this
      try {
        let data = null
        if (payload == null) return false

        const broadcast = vm.broadcastItems.find((el) => {
          return el.id == payload.id
        })
        if (broadcast) data = Object.assign({}, broadcast)
        if (data == null) return false

        vm.$swal
          .fire({
            // eslint-disable-next-line no-useless-escape
            title: vm.$t('Do you want to copy {name}?', { name: data.name.replace(/\<|\>/g, '') }),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then((result) => {
            if (result.value) {
              data.id = null
              data.name += ' copy'
              data.sendflag = false
              data.page_access_token = vm.selectedBot.page_access_token

              vm.$emit('onCopyBroadcast', data)
            }
          })
      } catch (error) {
        console.error(error)
      }
    },
    editBroadcast: function (broadcasts) {
      this.$emit('onEditBroadcast', broadcasts)
    },
    deleteBroadcast: function (broadcastId, broadcastName) {
      const vm = this
      try {
        vm.$swal
          .fire({
            title: vm.$t('Do you want to delete {name}?', {
              // eslint-disable-next-line no-useless-escape
              name: broadcastName.replace(/\<|\>/g, '')
            }),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then((result) => {
            if (result.value) {
              vm.$emit('onDeleteBroadcast', broadcastId)
            }
          })
      } catch (error) {
        console.error(error)
      }
    },
    viewBroadcast: function (index) {
      const vm = this
      try {
        vm.selectedViewBroadcast = this.broadcastItems[index]
        vm.viewBroadcastDialogOpen = true
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/tcp/Broadcast/BroadcastList.vue